import { render, staticRenderFns } from "./Batchappend.vue?vue&type=template&id=7b7edb2a&scoped=true"
import script from "./Batchappend.vue?vue&type=script&lang=js"
export * from "./Batchappend.vue?vue&type=script&lang=js"
import style0 from "./Batchappend.vue?vue&type=style&index=0&id=7b7edb2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7edb2a",
  null
  
)

export default component.exports